var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.43266C0 0.641875 0.662031 0 1.47812 0H18.5219C19.3383 0 20 0.641875 20 1.43266V18.5676C20 19.3586 19.3383 20 18.5219 20H1.47812C0.662109 20 0 19.3587 0 18.5678V1.43242V1.43266Z",
    fill: "#272D37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.07742 16.7375V7.73341H3.08461V16.7375H6.07773H6.07742ZM4.58164 6.50427C5.62508 6.50427 6.27469 5.81287 6.27469 4.9488C6.25516 4.06505 5.62508 3.39294 4.60148 3.39294C3.57719 3.39294 2.9082 4.06505 2.9082 4.94873C2.9082 5.81279 3.55758 6.50419 4.56203 6.50419H4.58141L4.58164 6.50427ZM7.73398 16.7375H10.7266V11.7097C10.7266 11.441 10.7461 11.1715 10.8252 10.9796C11.0414 10.4417 11.5338 9.8849 12.3608 9.8849C13.4434 9.8849 13.8768 10.7105 13.8768 11.9211V16.7375H16.8693V11.5748C16.8693 8.80927 15.393 7.52232 13.4241 7.52232C11.8098 7.52232 11.1008 8.42458 10.7069 9.03912H10.7268V7.73373H7.73414C7.7732 8.57841 7.73391 16.7378 7.73391 16.7378L7.73398 16.7375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.06fa4c72a1b5d779f10efca2d09c6780.svg";
export { ForwardRef as ReactComponent };